export const styles = {
  headerLogo: {
    overflow: 'hidden',
    height: '100%',

    '> img': {
      objectFit: 'contain',
    },
  },
};
